export { default as ContactCenterPerAgentReportFilters } from '@/views/pages/reports/contact-center-per-agent/components/ContactCenterPerAgentReportFilters.vue';
